import { MobileEnquireBarConfig } from '../mobile-enquire-bar/mobile-enquire-bar.types';

export const TRUST_MOBILE_ENQUIRE_CONFIG: MobileEnquireBarConfig = {
  label: 'Enquire Now',
  routerLink: '/',
  fragment: 'enquiry',
  hideWhenSectionId: 'enquiry',
  visibleOnlyOnRoutes: ['/', '/institutions'],
};
